export enum ViewModalFooterBlock {
  Root = 'ViewModalFooter',
}
